export default {
  grayHeader: "お支払い方法について",
  description: "銀行振込もしくはクレジットカード決済にてご購入いただけます。",
  bank: {
    header: "銀行振込",
    account:{
      header: "お振込み先口座",
      description: "ご注文完了後に弊社からお送りする「請求書発行Eメール」にてお振込み先口座をお知らせいたします。"
    },
    remitter: {
      header: "お振込み時の「依頼人名」",
      description: "銀行窓口もしくはATMにてお振込みいただく際の「振込依頼人名」はご注文時に入力いただいた振込依頼人名と、ご注文完了時に発行される数字6ケタの「注文番号」を併せてご入力願います。",
      tips: "注文番号はご注文完了画面もしくは「請求書」に記載されます。",
      additions: [
        "お振込み期限はご注文日より【1ヶ月】となります。期限を過ぎた場合はご注文のキャンセルとなりますのでご注意ください。",
        "お振込み手数料はお客様負担となります。"
      ]
    }
  },
  credit: {
    header: "クレジットカード決済",
    description: "ご利用可能なクレジットカードは下記となります。",
    tips: "領収書の発行は「注文確認」ページで発行いただけます。",
    additions: [
      "配送日の指定が可能です。",
      "クレジットカード決済では請求書の発行は承れませんのでご注意ください。",
      "セキュリティ強化のため、クレジットカードにてお支払いいただいたお客様を対象にご本人様確認を行わせていただくことがございます。\nその場合、商品の発送を一時的に保留させていただくことがございますので予めご了承願います。"
    ]
  }
};



// WEBPACK FOOTER //
// ./src/i18n/ja/about/payment/index.js